<div class="modal-header">
  <h4 class="modal-title cs-modal-title">TEACHER NICKNAME</h4>
  <button type="button" class="close" aria-label="Close" (click)="dialog.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<form (ngSubmit)="onSubmit()" ngNativeValidate>
  <div class="modal-body game-modal">
    <div class="form-group">
      <label class="form-label">Nickname:</label>
      <input type="text" class="form-control" name="nickname" [(ngModel)]="nickname">
    </div>
  </div>
  <div class="modal-footer d-flex">
    <button (click)="onCancel()"
            type="button" class="btn btn-secondary">Cancel</button>
    <button type="submit" class="btn btn-primary ml-auto">Save</button>
  </div>
</form>